import React from 'react'
import PropTypes from 'prop-types'
import { Columns, Column, Button, ButtonGroup } from '@resurs/midas-react'

export class WizardPage extends React.PureComponent {
  render() {
    const prevButton = () => {
      if (this.props.onPrevious !== null) {
        return (
          <Button
            text={this.props.prevText}
            size="large"
            onClick={this.props.onPrevious}
            disabled={this.props.prevDisabled}
          />
        )
      }
      return null
    }

    const nextButton = () => {
      if (this.props.onNext !== null) {
        return (
          <Button
            text={this.props.nextText}
            type="primary"
            size="large"
            disabled={this.props.nextDisabled}
            onClick={() => this.props.onNext()}
            loading={this.props.isLoading}
          />
        )
      }
      return null
    }

    return (
      <section id="wizardpage" style={{ marginLeft: '1rem' }}>
        <div>
          {this.props.children}
          <Columns>
            <Column col2 />
            <Column col8>
              <ButtonGroup>
                {prevButton()}
                {nextButton()}
              </ButtonGroup>
            </Column>
          </Columns>
        </div>
      </section>
    )
  }
}

WizardPage.propTypes = {
  children: PropTypes.object,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  prevText: PropTypes.string,
  nextText: PropTypes.string,
  prevDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
}

WizardPage.defaultProps = {
  children: null,
  onNext: null,
  onPrevious: null,
  prevDisabled: false,
  nextDisabled: false,
  isLoading: false,
  prevText: '',
  nextText: '',
}
